// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KJCWYz {
  max-width: 800px;
  width: 350px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: var(--border-radius-lg);
  margin-top: 24px;
}

.hbsFrd {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 350px;
}

.es79JY {
  width: 32px;
  height: 32px;
  filter: invert(21%) sepia(89%) saturate(3068%) hue-rotate(346deg) brightness(102%) contrast(106%);
  flex-shrink: 0;
}

.Oe3xAG {
  font-family: 'Clario', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: var(--color-neutral-900);
  margin-top: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
}

.rmC63f {
  font-weight: 400;
}

.KqCfKz {
  font-size: var(--font-size-lg);
  color: var(--color-neutral-700);
  line-height: var(--line-height-relaxed);
  max-width: 600px;
  align-self: center;
  margin-top: 16px;
}

/* Loading state */
.l1iULL {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-4);
}

.gkyobK {
  width: 48px;
  height: 48px;
  color: var(--color-primary-500);
  animation: SZb79b 1s linear infinite;
}

@keyframes SZb79b {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/ContractStatusPage.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iGAAiG;EACjG,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,oCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".statusCard {\n  max-width: 800px;\n  width: 350px;\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n  border-radius: var(--border-radius-lg);\n  margin-top: 24px;\n}\n\n.headerSection {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  width: 350px;\n}\n\n.headerIcon {\n  width: 32px;\n  height: 32px;\n  filter: invert(21%) sepia(89%) saturate(3068%) hue-rotate(346deg) brightness(102%) contrast(106%);\n  flex-shrink: 0;\n}\n\n.mainTitle {\n  font-family: 'Clario', sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--color-neutral-900);\n  margin-top: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-align: center;\n}\n\n.beneficiosSpan {\n  font-weight: 400;\n}\n\n.subtitle {\n  font-size: var(--font-size-lg);\n  color: var(--color-neutral-700);\n  line-height: var(--line-height-relaxed);\n  max-width: 600px;\n  align-self: center;\n  margin-top: 16px;\n}\n\n/* Loading state */\n.loadingContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-4);\n}\n\n.loadingIcon {\n  width: 48px;\n  height: 48px;\n  color: var(--color-primary-500);\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusCard": `KJCWYz`,
	"headerSection": `hbsFrd`,
	"headerIcon": `es79JY`,
	"mainTitle": `Oe3xAG`,
	"beneficiosSpan": `rmC63f`,
	"subtitle": `KqCfKz`,
	"loadingContainer": `l1iULL`,
	"loadingIcon": `gkyobK`,
	"spin": `SZb79b`
};
module.exports = ___CSS_LOADER_EXPORT___;
